import React, { Component } from 'react';
import { connect } from 'react-redux';

import { YCaption, YMap, YMapPoint, YClusterPoint } from '../../common/YMap';
import cn from 'classnames';
import styles from '../Map/Map.scss';
import { fitBounds } from 'google-map-react/utils';
import { ZOOM } from 'constants';
import SuperCluster from 'supercluster';
import { loadPoint, loadPointList } from '../../../actions/objects';
import YPlaceInfo from '../../common/YMap/YPlaceInfo';
import YPlaceInfoList from '../../common/YMap/YPlaceInfo/placeInfoList';
import { createSelector } from 'reselect';
import iconClose from 'assets/images/icons/icon-close.svg';

const size = {
  width: 800,
  height: 500,
};

const clusterOptions = {
  radius: 68,
  maxZoom: 14,
  minPoints: 10,
};

class MainMap extends Component {
  constructor(props) {
    super(props);

    const mapProps = this.fitBounds(props.data);
    const data = this.transformData(props.data);

    this.state = {
      mapProps,
      data,
      key: 1,
    };
  }

  componentWillReceiveProps(nextProps) {
    const { data: nextData } = nextProps;
    const { data } = this.props;
    if (nextData !== data) {
      const mapProps = this.fitBounds(nextData);
      const data = this.transformData(nextData);
      this.setState((state) => ({ data, mapProps, info: null, key: state.key + 1 }));

      if (this.map) {
        this.map.setCenter([mapProps.center.lat, mapProps.center.lng], mapProps.zoom);
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.data !== this.props.data && this.props.data.length > 0) {
      const mapProps = this.fitBounds(this.props.data);
      if (
        this.state.mapProps.center.lat !== mapProps.center.lat ||
        this.state.mapProps.center.lng !== mapProps.center.lng ||
        this.state.mapProps.zoom !== mapProps.zoom
      ) {
        this.setState({ mapProps });

        if (this.map) {
          this.map.setCenter([mapProps.center.lat, mapProps.center.lng], mapProps.zoom);
        }
      }
    }
  }

  transformData(data) {
    return data.map((place) => ({
      ...place,
      geometry: { coordinates: [place.longitude, place.latitude] },
    }));
  }

  map = null;

  fitBounds(data) {
    let maxLat = -Infinity,
      minLat = Infinity,
      maxLng = -Infinity,
      minLng = Infinity;

    if (data.length > 1) {
      data.forEach((item) => {
        const lat = parseFloat(item.latitude);
        const lng = parseFloat(item.longitude);

        if (lat > maxLat) maxLat = lat;
        if (lat < minLat) minLat = lat;
        if (lng > maxLng) maxLng = lng;
        if (lng < minLng) minLng = lng;
      });
    } else if (data.length === 1) {
      const lat = parseFloat(data[0].latitude);
      const lng = parseFloat(data[0].longitude);

      maxLat = lat + 0.005;
      minLat = lat - 0.005;
      maxLng = lng + 0.005;
      minLng = lng - 0.005;
    } else {
      return {
        center: { lat: 0, lng: 0 },
        zoom: 1,
      };
    }

    if (
      maxLat === -Infinity ||
      minLat === Infinity ||
      maxLng === -Infinity ||
      minLng === Infinity
    ) {
      return {
        center: { lat: 0, lng: 0 },
        zoom: 1,
      };
    }

    const bounds = {
      nw: {
        lat: maxLat,
        lng: minLng,
      },
      se: {
        lat: minLat,
        lng: maxLng,
      },
    };

    return fitBounds(bounds, size);
  }

  getClusters() {
    if (!(this.state.mapProps.bounds || this.state.mapProps.newBounds)) {
      return [];
    }

    const { data, mapProps } = this.state;
    const { zoom, bounds, newBounds } = mapProps;
    const { nw, se } = bounds || newBounds;

    const index = new SuperCluster({
      ...clusterOptions,
      map: (props) => ({
        ...props,
        clusteredPoints: [],
      }),
    });

    index.load(data);

    const clusters = index.getClusters([nw.lng, se.lat, se.lng, nw.lat], zoom);

    return clusters.map((cluster) => {
      const { properties } = cluster;

      if (properties && properties.cluster) {
        try {
          const clusteredPoints = index.getLeaves(properties.cluster_id, Infinity);
          return {
            ...cluster,
            properties: {
              ...properties,
              clusteredPoints,
            },
          };
        } catch (error) {
          console.error('Ошибка при получении точек кластера:', error);
          return cluster;
        }
      }

      return cluster;
    });
  }

  handleMapLoad = (ymaps) => {
    const myMap = this.map;

    myMap.events.add('boundschange', (event) => {
      const points = event
        .get('newBounds')
        .map(([latitude, longitude]) => ({ latitude, longitude }));
      const mapProps = this.fitBounds(points);

      this.setState({
        mapProps,
      });
    });
  };

  renderCaptions() {
    const { cities } = this.props;
    const {
      mapProps: { zoom },
    } = this.state;

    const captions =
      zoom >= ZOOM
        ? cities
            .map(
              (city) =>
                city.areas &&
                city.areas.map(
                  (area) =>
                    area.subareas &&
                    area.subareas.map((subarea) => ({
                      name: subarea.name,
                      lat: parseFloat(subarea.latitude),
                      lng: parseFloat(subarea.longitude),
                    }))
                )
            )
            .flat(2)
            .filter(Boolean)
        : cities
            .map(
              (city) =>
                city.areas &&
                city.areas.map((area) => ({
                  name: area.name,
                  lat: parseFloat(area.latitude),
                  lng: parseFloat(area.longitude),
                }))
            )
            .flat(1)
            .filter(Boolean);

    return captions.map(({ name, lat, lng }) => (
      <YCaption name={name} lat={lat} lng={lng} key={`${name}-${lat}-${lng}`} />
    ));
  }

  handleShowInfo = (item, info) => {
    const { id } = item;
    const { points, dispatch } = this.props;
    this.setState({
      infoList: null,
    });

    const clusterData = Boolean(item.properties);

    const longitude = clusterData ? item.geometry.coordinates[0] : item.longitude;
    const latitude = clusterData ? item.geometry.coordinates[1] : item.latitude;
    const longLat = `${longitude}-${latitude}`;

    this.setState({
      info: clusterData ? { ...item.properties.clusteredPoints, id: longLat } : { ...info, id },
    });

    this.map.setCenter([latitude, longitude]);

    if (points && !points[id]) {
      dispatch(loadPoint(id));
    }
  };

  handleShowListInfo = (item, info) => {
    const { points, pointsList } = this.props;

    const longitude = item.geometry.coordinates[0];
    const latitude = item.geometry.coordinates[1];

    this.map.setCenter([latitude, longitude]);

    const clusterPointIds = item.properties.clusteredPoints.map((obj) => Number(obj.id)) || [];
    const longLat = `${longitude}-${latitude}`;

    this.setState({
      infoList: { ...info, longLat },
    });

    if (points && !pointsList[longLat]) {
      const { dispatch } = this.props;
      dispatch(loadPointList(clusterPointIds, longLat));
    }
  };

  handleCloseInfo = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ info: null, infoList: null });
  };

  render() {
    const { className, points, infoType, pointsList } = this.props;

    const {
      mapProps: { center, zoom, newBounds },
      info,
      infoList,
    } = this.state;
    const clusters = this.getClusters();

    const places = clusters.map((item) => {
      if (item.geometry.type) {
        const {
          properties: { point_count: pointCount },
          geometry: {
            coordinates: [longitude, latitude],
          },
        } = item;

        return (
          <YClusterPoint
            name={pointCount}
            pointCount={pointCount}
            lat={latitude}
            lng={longitude}
            onClick={this.handleShowListInfo.bind(this, item)}
            key={`${pointCount}-${latitude}-${longitude}`}
            item={item}
          />
        );
      }

      const { longitude, latitude, id } = item;

      let contexuality;
      const isActive = false;

      if (Number(item.count_flats) === 0) {
        contexuality = 'disabled';
      } else if (item.construction_finished) {
        contexuality = isActive ? 'active' : 'success';
      } else {
        contexuality = isActive ? 'warningActive' : 'warningSuccess';
      }

      if (item.status == 3) {
        contexuality = 'almostFinished';
      }

      return (
        <YMapPoint
          key={id}
          id={id}
          lat={+latitude}
          lng={+longitude}
          onClick={this.handleShowInfo.bind(this, item)}
          contexuality={contexuality}
          isActive={this.state.info && this.state.info.id === id}
        />
      );
    });

    return (
      <div className={cn(styles.Map, className)}>
        <YMap
          key={this.state.key}
          defaultState={{
            center: [center.lat, center.lng],
            zoom,
          }}
          defaultOptions={{
            restrictMapArea: [
              [newBounds.sw.lat - 1.5, newBounds.sw.lng - 1.5],
              [newBounds.ne.lat + 1.5, newBounds.ne.lng + 1.5],
            ],
          }}
          instanceRef={(ref) => (this.map = ref)}
          onLoad={this.handleMapLoad}
        >
          {info && points && points[info.id] && (
            <div className={styles.MapInfo}>
              <YPlaceInfo
                onClose={this.handleCloseInfo}
                infoType={infoType}
                point={points[info.id]}
              />
            </div>
          )}
          {infoList && pointsList[infoList.longLat] && (
            <div className={styles.MapInfoList}>
              {pointsList[infoList.longLat].map((point) => (
                <YPlaceInfoList infoType={infoType} point={point} longLat={infoList.longLat} />
              ))}
              <img
                src={iconClose}
                alt=""
                onClick={(e) => this.handleCloseInfo(e)}
                className={styles.CloseListButton}
              />
            </div>
          )}
          {this.renderCaptions()}
          {places}
        </YMap>
      </div>
    );
  }
}

const citiesSelector = createSelector(
  (state) => state.building.cities,
  (state) => state.objects.pointsList,
  (_, props) => props,
  (cities, pointsList, props) => ({
    cities,
    pointsList,
    someProp: props.someProp,
  })
);

export default connect(citiesSelector)(MainMap);



// WEBPACK FOOTER //
// ./src/components/Buildings/YMap/index.js